// @ts-nocheck
import React, { useState } from 'react';
import {
  loadKeyProviders,
  exportKeyProviderData,
} from '../../../../actions/keyProviderActions';
import { Table, SimpleTextFilter, getVisibleColumns } from '../../../common/Table';
import { CommaNumber_NoDecimal, hexToRgbA } from '../../../../util/formatter';
import Loading from '../../../common/Loading';
import KwPanel from '../../../common/KwPanel';
import {
  useTableSettings,
  getTableSettingsDefaults,
} from '../../../../hooks/useTableSettings';
import KeyProviderLink from '../../../common/links/KeyProviderLink';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

function KeyProviderList({ reload }) {
  const allColumns = [
    'name',
    'isActivatedCodeCount',
    'isAllocatedCodeCount',
    'isAvailableCodeCount',
    'isDisabledCodeCount',
    'isSoldCodeCount',
  ];
  const { t } = useTranslation();
  const defaultVisibleColumns = allColumns;
  const [keyProviders, setKeyProviders] = useState();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const { tableSettings, handleSetTableSettings: setTableSettings, filters, filterChange, isLoading } =
    useTableSettings(
      'keyproviderlist-settings',
      getTableSettingsDefaults({ defaultSort: 'name', defaultVisibleColumns }),
      null,
      loadKeyProviders,
      setKeyProviders,
      reload,
      t('Failed to load key providers')
    );

  // The base config of the columns, this will be filtered based on the visible (above)
  let columnsConfig = [
    {
      Key: 'name',
      Label: t('Name'),
      className: 'flush',
      width: '40%',
      Render: (keyProvider) => (
        <div
          className="p-2 d-flex align-items-center company-td"
          style={
            keyProvider.colourHex
              ? {
                  borderLeft: `3px solid ${keyProvider.colourHex}`,
                }
              : null
          }
        >
          <KeyProviderLink
            id={keyProvider.id}
            name={keyProvider.name}
            imageId={keyProvider.imageId}
            imageSize={32}
          />
        </div>
      ),
      Filter: {
        Render: (col) => (
          <SimpleTextFilter
            Key={col.Key}
            Value={col.filterValue ?? params.get(`f_${col.Key}`) ?? ''}
            onChange={(value) => filterChange(col.Key, value)}
          />
        ),
      },
    },
    {
      Key: 'isAvailableCodeCount',
      Label: t('Pooled'),
      width: '12%',
      className: 'text-right num no-wrap',
      Render: (keyProvider) =>
        CommaNumber_NoDecimal(keyProvider.isAvailableCodeCount),
    },
    {
      Key: 'isAllocatedCodeCount',
      Label: t('Delivered'),
      width: '12%',
      className: 'text-right num no-wrap',
      Render: (keyProvider) =>
        CommaNumber_NoDecimal(keyProvider.isAllocatedCodeCount),
    },
    {
      Key: 'isSoldCodeCount',
      Label: t('Sold'),
      width: '12%',
      className: 'text-right num no-wrap',
      Render: (keyProvider) =>
        CommaNumber_NoDecimal(keyProvider.isSoldCodeCount),
    },
    {
      Key: 'isActivatedCodeCount',
      Label: t('Activated'),
      width: '12%',
      className: 'text-right num no-wrap',
      Render: (keyProvider) =>
        CommaNumber_NoDecimal(keyProvider.isActivatedCodeCount),
    },
    {
      Key: 'isDisabledCodeCount',
      Label: t('Disabled'),
      width: '12%',
      className: 'text-right num no-wrap',
      Render: (keyProvider) =>
        CommaNumber_NoDecimal(keyProvider.isDisabledCodeCount),
    },
  ];

  // filter
  const visibleColumns = tableSettings.columns ?? defaultVisibleColumns;
  const columns = getVisibleColumns(visibleColumns, columnsConfig);

  // return an alaska table
  return keyProviders ? (
    <KwPanel className="mb-4">
      <Table
        columns={columns}
        allColumns={allColumns}
        rows={keyProviders.data.map((x) => {
          return { Key: x.id, ...x };
        })}
        totalRowCount={keyProviders.totalRowCount}
        filteredRowCount={keyProviders.filteredRowCount}
        tableSettings={tableSettings}
        setTableSettings={setTableSettings}
        isLoading={isLoading}
        filters={filters}
        filterChange={filterChange}
        trStyle={(row) => {
          return {
            backgroundColor: `${hexToRgbA(row.colourHex, 0.0375)}`,
          };
        }}
        exportData={exportKeyProviderData}
      />
    </KwPanel>
  ) : (
    <Loading></Loading>
  );
}

export default KeyProviderList;
